'use client';

import { createContext, ReactElement, useContext, useMemo, useRef } from 'react';
import { AppAnalyticsClient } from '@nimbus/app-analytics-client/lib/client/AppAnalyticsClient';
import { AppAnalyticsClientStub } from '@nimbus/app-analytics-client/lib/client/AppAnalyticsClientStub';
import { IAppAnalyticsClient } from '@nimbus/app-analytics-client/lib/client/IAppAnalyticsClient';

type Value = {
  analytics: IAppAnalyticsClient;
};

const Context = createContext<Value>({
  analytics: new AppAnalyticsClientStub(),
});

export type AppAnalyticsContextProviderProps = {
  children: ReactElement;
  serviceUrl: string;
  datadogApplicationId: string;
  datadogClientToken: string;
  env: string;
  service: string;
  disabled?: boolean;
};

const AppAnalyticsContextProvider = (props: AppAnalyticsContextProviderProps) => {
  const isInitialized = useRef(false);

  const analytics = useMemo(() => {
    if (isInitialized.current) {
      return new AppAnalyticsClientStub();
    }

    const analyticsClient = new AppAnalyticsClient({
      appAnalyticsServiceUrl: props.serviceUrl,
      datadogApplicationId: props.datadogApplicationId,
      datadogClientToken: props.datadogClientToken,
      env: props.env,
      service: props.service,
      disabled: props.disabled,
    });

    isInitialized.current = true;

    return analyticsClient;
  }, [isInitialized]);

  return <Context.Provider value={{ analytics }}>{props.children}</Context.Provider>;
};

export const useAnalytics = () => useContext(Context);

export default AppAnalyticsContextProvider;
